var _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 61,
    viewBox: "0 0 33 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 6,
    r: 6,
    fill: "url(#paint0_radial_78_5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 48.5,
    r: 12.5,
    fill: "url(#paint1_radial_78_5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 28.5,
    r: 7.5,
    fill: "url(#paint2_radial_78_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.24 6.24) rotate(92.3859) scale(5.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E8B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 49) rotate(92.3859) scale(12.0104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E8B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_78_5",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8 28.8) rotate(92.3859) scale(7.20625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E8B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBubbles);
export default __webpack_public_path__ + "static/media/ThreeBubbles.035bb711adf538c16ed59ef4ef492a0a.svg";
export { ForwardRef as ReactComponent };